import React from 'react';

export const FeatureGridIllustration: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = (props) => (
  <div>
    <img alt="" {...props} style={{ height: '40px', ...props.style }} />
  </div>
);
